export const GET_KYC_FIELD_LIST = 'GET_KYC_FIELD_LIST'
export const SET_KYC_FIELD_LIST = 'SET_KYC_FIELD_LIST'
export const SEND_KYC_FIELD = 'SEND_KYC_FIELD'
export const DELETE_KYC_FIELD = 'DELETE_KYC_FIELD'

export const SET_VERIFICATION_FIELDS_TAB = 'SET_VERIFICATION_FIELDS_TAB'
